
export default {
  recshares: [],
  total:0,
  max:10,
  offset:0,
  sort: 'id',
  order: 'ascending'
};
